import React, { useState } from 'react';
import { ISubMenu, ISubMenuOption } from './interfaces';
import { Collapse, List } from '@mui/material';
import { SubMenuItem } from './components/SubMenuItem';
import { useLocation, useNavigate } from 'react-router';

export const SubMenu: React.FC<ISubMenu> = ({
  show,
  menuOptions,
}): JSX.Element => {
  const location = useLocation();
  const [activeMenuItem, setActibeMenuItem] = useState<string | null>(null);
  const navigate = useNavigate();

  const onSubMenuOptionClick = (option: ISubMenuOption): void => {
    setActibeMenuItem(option.key);
    navigate(option.link);
  };

  const isMenuOptionActive = (menuOptionLink: string): boolean => {
    if (menuOptionLink === '/' && location.pathname !== menuOptionLink) {
      return false;
    }

    return location.pathname.startsWith(menuOptionLink);
  };

  return (
    <Collapse in={show} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        {menuOptions.map((option) => (
          <SubMenuItem
            key={option.key}
            label={option.label}
            onClick={() => onSubMenuOptionClick(option)}
            active={isMenuOptionActive(option.link)}
          />
        ))}
      </List>
    </Collapse>
  );
};
